import(/* webpackMode: "eager" */ "/app/src/app/contact/global/page.tsx");
